import {Flex, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React, {useRef} from 'react';
import texts from '../../../texts';
import styles from '../../styles.module.scss';
import {isRTL} from '../../../../../Localization';
import {featuresIDs} from '../../../../FeaturePopover/constants/map';
import {featurePopoverRef} from '../../../../FeaturePopover/FeaturePopover.root';
import {PopoverContent} from '../../../../FeaturePopover/FeaturePopover';

const Indicator = ({styleMode}) => {
    return (
        <div>
            <div className={styleMode} />
        </div>
    );
};

const getFeautureContent = () => {
    const dataStepText = texts.dataStep;
    const contentParts = texts.nextStepMessage.split(dataStepText);
    return (
        <Text tag="p">
            {contentParts[0]}
            <Text tag="span" fontWeight="bold">
                {dataStepText}
            </Text>
            <Text tag="span">{contentParts[1]}</Text>
        </Text>
    );
};

export const TabTracker = ({showIncomplete, showComplete, tabId, isLast, showFeaturePopover}) => {
    const ref = useRef<HTMLDivElement>(null);

    const popoverContent: PopoverContent = {
        title: texts.nextStepTitle,
        content: getFeautureContent(),
        secondaryButtonText: null,
        primaryButtonText: texts.promoOkBtn
    };

    showFeaturePopover &&
        ref?.current &&
        featurePopoverRef?.current?.showFeaturePopover(
            featuresIDs.chartProcessWizard,
            ref.current,
            null,
            null,
            popoverContent
        );

    return (
        <Flex
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            componentClasses={styles.flexGap}
        >
            {showIncomplete ? (
                <Indicator styleMode={styles.stepperIndicator} />
            ) : showComplete ? (
                <Icon icon={PriorityIcon.roundCheck} iconColor="primary-500" />
            ) : (
                <Indicator styleMode={styles.emptyIndicator} />
            )}
            {!isLast && <div ref={ref} />}
            <Text>{texts[`${tabId}Step`]}</Text>
            {!isLast && (
                <Icon
                    icon={isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                    componentClasses={styles.arrowIcon}
                />
            )}
        </Flex>
    );
};
